// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"246":"53cbeb63f1fa09aa","506":"4e39becd270b21dc","664":"8f3496e09c00d8da","907":"d9ccac20bddf06ae","923":"81d8337124f833f8"}[chunkId] + ".js";
};